import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Avatar,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { ExpandMore, ExpandLess, ArrowBack } from "@mui/icons-material";
import SummarizeIcon from "@mui/icons-material/Summarize";
import CleanHandsIcon from "@mui/icons-material/CleanHands";
import PreviewIcon from "@mui/icons-material/Preview";
import { useMediaQuery } from "@mui/material";

import Accountmenu from "../menu/Accountmenu";
import logo from "../../assets/images/logotalent.png";
import logoMan from "../../assets/images/logoman.png";
import { useLocation, useNavigate } from "react-router-dom";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { s3baseUri } from "../../config/config";
import { enqueueSnackbar } from "notistack";
import {
  candidate_api_detail_fetch,
  client_detail_api,
  get_outside_jobs_api,
} from "../../DAL/partner/partners";
import { useIds } from "../../hook/AdminContext";
import RecordNotFound2 from "../recordNotFound/SataNitFound";
import { is_small_medium_screen, sourceAccessMap } from "../../utils/Constant";
import { Icon } from "@iconify/react/dist/iconify.js";
import PostJoboUTSIDE from "../../pages/post/PostJobOutSide";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [profileImage, setProfileImage] = useState();
  const { profileNewImage, breadCrumb, userInfo, findId } = useIds();
  const [isHitFirst, setIsHitFirst] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [detailData, setDetailData] = useState(null);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sourceId, setsourceId] = useState(null);
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [partnersObj, setPartnersObj] = useState({});
  const [open, setOpen] = useState(false);

  const [editMode, setEditMode] = useState(false);

  const load_more_path = "api/jobs/list?page=0&limit=50";

  const openAccount = Boolean(anchorEl);
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const firstSegment = location.pathname.split("/")[1];

  const handleOpen = () => {
    setOpen(true);
    setEditMode(false);
  };

  const handleOpenEditJob = (job) => {
    setEditMode(true);
    setSelectedJob(job);
    setOpen(true);
  };

  const handleNavigate = () => {
    navigate("/favourite-jobs");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const matched = breadCrumb
    .filter((item) => pathname.startsWith(item.path) && item.path !== "")
    .sort((a, b) => b.path.length - a.path.length)[0];

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseJobPanel = () => {
    setOpen(false);
  };

  const handleHome = () => {
    navigate("/home");
  };

  const smartBack = () => {
    if (matched && matched?.path !== pathname) {
      navigate(matched.path);
    } else {
      navigate(`/home`);
    }
  };

  const handleSummarizeClick = () => {
    if (userInfo?.type === 2) {
      const accessibleSource = sourceAccessMap.find(({ title }) =>
        userInfo?.source?.some((source) => source.title === title)
      );
      navigate(accessibleSource?.path || "/home");
    }
  };
  const ismobile = useMediaQuery("(max-width:600px)");

  const showBackButton = pathname !== "/dashboard" && pathname !== "/home";
  const iconColor = "#000080";

  useEffect(() => {
    const timer = setTimeout(() => {
      setProfileImage(profileNewImage);
    }, 1000);
    return () => clearTimeout(timer);
  }, [profileNewImage]);

  return (
    <>
      <PostJoboUTSIDE
        refreshlist={() => {}}
        loadMorePath={load_more_path}
        searchTerm={searchTerm}
        loadingstate={loading}
        id={findId || localStorage.getItem("source_id")}
        open={open}
        handleClose={handleCloseJobPanel}
        editMode={editMode}
        jobData={selectedJob}
        sourceId={sourceId}
      />
      {!ismobile && (
        <AppBar
          position="fixed"
          sx={{
            backgroundColor: "#fff",
            boxShadow: 1,
            marginBottom: "10px",
          }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {showBackButton && (
                <Tooltip title="Go Back">
                  <span>
                    <IconButton
                      onClick={smartBack}
                      aria-label="Go Back"
                      type="button"
                      size="medium"
                      sx={{
                        color: iconColor,
                        animation: "bounceLeftRight 1s infinite",
                        "&:hover": {
                          animation: "none",
                          backgroundColor: "rgba(118, 118, 149, 0.1)",
                        },
                      }}
                    >
                      <ArrowBack />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  minHeight: { xs: "auto", sm: 0 },
                }}
              >
                <img
                  onClick={handleHome}
                  src={logo}
                  alt="Logo"
                  style={{ width: "180px", height: "60px", cursor: "pointer" }}
                />
              </Box>
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
              {Array.isArray(userInfo?.source) &&
                userInfo.type === 1 &&
                userInfo.source.length > 0 && (
                  <Tooltip title="View Favorite Jobs">
                    <IconButton
                      onClick={handleNavigate}
                      size="small"
                      sx={{ p: 0.5, color: "#000080" }}
                    >
                      <BookmarkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}

              {userInfo?.type === 2 && (
                <>
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                      cursor: "pointer",
                      color: "#000080",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 128, 0.05)",
                        borderRadius: "4px",
                      },
                    }}
                    onClick={handleOpen}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 500, mr: 1 }}>
                      Post Job
                    </Typography>
                    <Icon icon="ic:round-post-add" width={24} height={24} />
                  </Box>

                  {/* Vertical separator */}
                  <Box
                    component="span"
                    sx={{
                      height: "20px",
                      width: "1px",
                      backgroundColor: "rgba(0, 0, 0, 0.12)",
                      mx: 0.1,
                    }}
                  />

                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                      cursor: "pointer",
                      color: "#000080",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 128, 0.05)",
                        borderRadius: "4px",
                      },
                    }}
                    onClick={handleSummarizeClick}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 500, mr: 1 }}>
                      My Jobs
                    </Typography>
                    <Icon
                      icon="streamline-flex:search-category-remix"
                      width={18}
                      height={18}
                    />
                  </Box>
                </>
              )}

              <IconButton
                onClick={handleClick}
                sx={{
                  color: "#000080",
                  position: "relative",
                  p: 0,
                  marginLeft: "6px",
                }}
              >
                <Box sx={{ position: "relative", display: "inline-block" }}>
                  <Avatar
                    src={s3baseUri + userInfo?.profile_image}
                    sx={{ width: 40, height: 40 }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: -8,
                      bgcolor: "#fff",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {openAccount ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </Box>
                </Box>
              </IconButton>
            </Box>

            <Accountmenu
              anchorEl={anchorEl}
              open={openAccount}
              handleClose={handleClose}
            />
          </Toolbar>
        </AppBar>
      )}
    </>
  );
};

export default Header;
